import axios from 'axios';
import {BASEDOMAIN} from '@/constants/allconstants';
import {AuthConfig} from '@/utils/constants/configContants';

export type FormListType = 'pdf' | 'web';

export const fetchForms = async (
    pageNo: number,
    dataLength: number,
    sorting: any,
    filter: any,
    searchItem: string | null,
    callback: any,
    errorCallback: any,
    formType: FormListType = 'pdf',
) => {
    const offset = dataLength * pageNo - dataLength;
    const type = formType === 'web' ? 'web' : 'pdf';
    const params = new URLSearchParams({
        offset: String(offset),
        limit: String(dataLength),
        sort: JSON.stringify(sorting),
        type,
    });
    if (searchItem) {
        params.set('search', searchItem);
    }
    if (filter.createdAtStart) {
        params.set('created_on_or_after', filter.createdAtStart);
    }
    if (filter.createdAtEnd) {
        params.set('created_on_or_before', filter.createdAtEnd);
    }
    if (filter.status) {
        params.set('status', filter.status.value);
    }
    if (filter.owner) {
        params.set('owner', filter.owner);
    }

    const url = `${BASEDOMAIN}/form/list?${params.toString()}`;
    await axios.get(url, AuthConfig()).then((response) => {
        callback(response);
    })
    .catch((e) => {
        errorCallback(e);
        console.log(e);
    });
}

export const getFormById = async (id: string, callBack: any, errCallback: any, after = () => {}, get_template = true) => {
    await axios.get(`${BASEDOMAIN}/form/${id}${get_template ? '?get_template=true' : ''}`, AuthConfig()).then((res) => {
        callBack(res.data);
        after();
    }).catch(e => e?.response?.status === 401 ? {} : errCallback(e))
}

export const fetchFormEnvos = async (formId: string, pageNo: number, dataLength: number, sorting: any, filter: any, searchItem: string, callback: any, errorCallback: any) => {
    const offset = dataLength * pageNo - dataLength;
    let url = searchItem
    ? `${BASEDOMAIN}/form/${formId}/envelope?offset=${offset}&limit=${dataLength}&sort=${JSON.stringify(sorting)}&search=${searchItem}&admin_portal=true`
    : `${BASEDOMAIN}/form/${formId}/envelope?offset=${offset}&limit=${dataLength}&sort=${JSON.stringify(sorting)}&admin_portal=true`;
    if (filter.createdAtStart) {
        url += `&created_on_or_after=${filter.createdAtStart}`;
    }

    if (filter.createdAtEnd) {
        url += `&created_on_or_before=${filter.createdAtEnd}`;
    }

    if (filter.status) {
        url += `&status=${filter.status.value}`;
    }

    await axios.get(url, AuthConfig()).then((response) => {
        callback(response);
    })
    .catch((e) => {
        errorCallback(e);
        console.log(e);
    });
}

export const transferFormOwnership = async (formId: string, payload: { user_id?: string; email_address?: string }) => {
    const response = await axios.post(`${BASEDOMAIN}/form/${formId}/transfer-ownership`, payload, AuthConfig());
    return response.data;
};

export const transferBulkFormOwnership = async (payload: {
    form_ids: string[];
    user_id?: string;
    email_address?: string;
}) => {
    const response = await axios.post(`${BASEDOMAIN}/form/transfer-ownership`, payload, AuthConfig());
    return response.data;
};